import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

// WorkComp Component
const ServiceComp = ({ title, description }) => {
  return (
    <Col xs={12} sm={6} md={4} className="mb-4" >
      <Card className="h-100" style={{padding:"2.1rem 0"}}>
        <Card.Body>
          <Card.Title style={{fontWeight:"700",fontSize:"1.4rem",color:"var(--primary)"}}>{title}</Card.Title>
          <Card.Text className="text" style={{fontSize:"0.9em"}}>
            {description}
          </Card.Text>
        </Card.Body>
      </Card>
    </Col>
  );
}

// Work Component
const Service = () => {
  return (
    <Container className="my-5">
      <h2 className="text-center mb-4 homepage-head" >Servies We Offer</h2>
      <Row className="text-center" style={{display:"flex",justifyContent:"center"}}>
        <ServiceComp
       
          title="Standard Essay Grading "
          description="Perfect for regular assignments, receive detailed feedback on all aspects of your essay"
        />
        <ServiceComp
        
          title=" College Application"
          description=" Get critical insights on your college application essays to make your submission stand out"
        />
        <ServiceComp
       
          title="Research Paper Evaluation"
          description="Comprehensive reviews for research papers, including structure, content, and citation checks."
        />
        <ServiceComp
        
          title="Thesis and Dissertation Review"
          description=" Detailed feedback for longer academic projects, ensuring clarity, coherence, and academic rigor"
        />
        <ServiceComp
        
        title="Editing and Proofreading"
        description="Beyond grading, we offer professional editing and proofreading services to polish your work to perfection."
      />
      </Row>
    </Container>
  );
}

export default Service;
